(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('ClonePlanController', ClonePlanController);

    ClonePlanController.$inject = ['$sce','$controller', '$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];
    
    function ClonePlanController($sce, $controller, $uibModalInstance, parameters, SoopkitchenUtils, Planning, PlanTypes) {
        
        var title = 'Clone Plan <span class="label label-info">'+parameters.labelToClone+'</span>, Version <span\n' +
            'class="label label-info">'+parameters.internalVersionToClone+'</span>';

        angular.extend(this, $controller('SoopkitchenDialogController', {
            "title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        var vm = this;

        /**** Properties ****/

        vm.planType = parameters.planType;
        vm.labelToClone = parameters.labelToClone;
        vm.internalVersionToClone = parameters.internalVersionToClone;
        vm.isMaster = vm.planType === PlanTypes['master'];
        vm.parameters = [];
        vm.parameters.push({'name': 'Label'});
        if (vm.isMaster) {
            vm.parameters.push({'name': 'ID'});
        }
        vm.parameter = {};
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveText = "Clone";

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = clone;
        
        function successCloning() {
            SoopkitchenUtils.invokeSweetAlert("Nice!", "You have created the plan " + vm.parameter['Label'], "success", vm.clear);
        }
        
        function failureCloning(response) {
            SoopkitchenUtils.prettyError(response);
        }
        
        function clone() {
            var planningParameters ={
                planType: vm.planType,
                planLabel: vm.parameter['Label'],
                planLabelToClone : vm.labelToClone,
                internalVersionToClone : vm.internalVersionToClone
            };
                
            if (vm.isMaster) {
                planningParameters.planId = vm.parameter['ID'];
            }
            
            Planning.clone(
                planningParameters,
                successCloning,
                failureCloning
            )
        }
    }
})();
